// src/lib/render/strip-markdown.ts
//
// Crude markdown → plain text for the lesson and flashcard PDF exports.
//
// Escape-aware about dollars: lesson content writes money as `\$12` (a bare `$`
// is a math delimiter on the page — lesson-content-check.ts). Stripping math
// spans with a plain /\$([^$]+)\$/ paired an escaped money sign with the next
// one ("\$12 each and \$8" lost both signs and kept a stray backslash), so an
// escaped dollar is set aside first and comes back as a plain "$".

const ESCAPED_DOLLAR = '\u0000'

export function stripMarkdown(s: string, opts: { lesson?: boolean } = {}): string {
  let out = s.replace(/\\\$/g, ESCAPED_DOLLAR)
  out = out
    .replace(/`([^`]+)`/g, '$1')
    .replace(/\*\*([^*]+)\*\*/g, '$1')
    .replace(/\*([^*]+)\*/g, '$1')
    .replace(/\$([^$]+)\$/g, '$1')
  if (opts.lesson) out = out.replace(/\[\[diagram:[^\]]+\]\]/g, '').replace(/#+\s*/g, '')
  return out.replace(new RegExp(ESCAPED_DOLLAR, 'g'), '$').replace(/\s+/g, ' ').trim()
}
